export default {
    //不需要保活的组件
    exclude:"",
}
